// app/components/BookSchema.tsx

interface BookSchemaProps {
  name: string;
  description?: string;
  image?: string[];
  url?: string;
  inLanguage?: string;
  numberOfPages?: number;
  bookFormat?: "EBook" | "Hardcover" | "Paperback" | "AudiobookFormat";
  bookEdition?: string;
  keywords?: string;
  author?: {
    name: string;
    url?: string;
  };
  publisher?: {
    name: string;
    logo: string;
    url: string;
  };
}

export function BookSchema({
  name,
  description,
  image,
  url,
  inLanguage,
  numberOfPages,
  bookFormat,
  bookEdition,
  keywords,
  author,
  publisher,
}: BookSchemaProps) {
  const imageArray = image ? (Array.isArray(image) ? image : [image]) : undefined;

  const schema = {
    "@context": "https://schema.org",
    "@type": "Book",
    name,
    ...(description && { description }),
    ...(imageArray && imageArray.length > 0 && { image: imageArray }),
    ...(url && { url }),
    ...(inLanguage && { inLanguage }),
    ...(numberOfPages && { numberOfPages }),
    ...(bookFormat && { bookFormat: `https://schema.org/${bookFormat}` }),
    ...(bookEdition && { bookEdition }),
    ...(keywords && { keywords }),
    ...(author && {
      author: {
        "@type": "Person",
        name: author.name,
        ...(author.url && { url: author.url }),
      },
    }),
    ...(publisher && {
      publisher: {
        "@type": "Organization",
        name: publisher.name,
        logo: {
          "@type": "ImageObject",
          url: publisher.logo,
        },
        ...(publisher.url && { url: publisher.url }),
      },
    }),
  };

  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />;
}
